<template>
  <nav class="navbar navbar-default navbar-fixed-top navbar-app">
    <div class="nav-default"></div>
    <div class="container">
      <div class="col-lg-10 col-lg-offset-1">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="###">
            <img src="../../../src/assets/images/footer-left.png" alt="Steer logo">
          </a>
          <!-- <div class="select-wrap">
              <select v-model="varLang" @change="langChange(varLang)">
                  <option value="zh">简体中文</option>
                  <option value="tc">繁体中文</option>
              </select>

          </div> -->
        </div>
        <div class="navbar-collapse collapse navbar-right">
          <ul class="nav navbar-nav fontColor">
            <li v-for="(module,index) in modules" :key='index' :class="{activeUnderline:activeTo == module.to}" @click="selected(module.to)">
              <router-link :to="module.to">{{$t(`header.${module.name}`)}}</router-link>
            </li>
            <li class="portals-title-page">
              <a href="javascript:0;">{{$t("header.others")}}</a>
              <div class="portal-subset-hide"></div>
              <ul class="portal-subset-page">
                <li><a href="https://portal.tintinhealth.com/ysmh">{{$t("header.other_option1")}}</a></li>
                <li><a href="https://ttapi.tintinhealth.com:9000/ddmanager">{{$t("header.other_option2")}}</a></li>
              </ul>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </nav>

</template>

<script>
    export default {
        name: '',
        data () {
            return {
              modules:[
                {name:'home',to:'/Home'},
                {name:'service',to:'/Service'},
                {name:'about',to:'/About'},
                {name:'contact',to:'/Contact'}
              ],
              activeTo:'/Home',
              varLang:'zh'
            }
        },
        mounted() {
            this.varLang = localStorage.getItem('languageStorage') || 'zh';

        },
        methods:{
          selected:function (to) {
              $('.fontColor>li').eq(2).removeClass('activeUnderline');
              if (typeof to != 'string') return;
              this.activeTo = to;
              // console.log(this.varLang)
              // if(to == '/Home'){window.location.reload()};
              // console.log(this.activeTo);
          },
          langChange(lang){
              console.log(lang);
              localStorage.setItem('languageStorage',lang);
              location.reload();
          }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='css' scoped>
  @import '../../../src/assets/css/style.css';
  .navbar-brand{padding:0;}
  .fontColor>li>a{color:white;}
  .navbar-default{opacity: 1;}
  .select-wrap{
      display: flex;
      align-items: center;
  }

  .portal-subset-hide{display:none;opacity: 0.5; margin-top:4px;position: absolute;width:100%;height:75px;background-color:#46b8da;}
  .portal-subset-page{display:none;padding-top:4px;position: absolute;width:100%;text-align: center;}
  .portal-subset-page>li{padding:4px 0;}
  .portal-subset-page>li>a{display:inline-block;margin:4px 0;color:#fff;}
  .portal-subset-page>li:hover a{text-decoration: none; border-bottom:1px solid #fff;}
  .portals-title-page{position: relative;}
  .portals-title-page:hover .portal-subset-hide{display: block;}
  .portals-title-page:hover .portal-subset-page{display: block;}
  @media screen and (max-width: 768px) {
    .portals-title-page{display: none;}
  }
</style>



// WEBPACK FOOTER //
// Header.vue?42c6861a